// import Config from 'react-native-config';

// console.log(Config, process.env);
const BASE_URL = process.env.REACT_APP_MONGODB_URL;

export const APIS = {
  BASE_URL: BASE_URL,
  request_otp: `/admin/request_otp`,
  login: `/admin/login`,
  refresh_token: `/admin/refreshToken`,
  logout: `/admin/logout`,
  create_txn: "/transactions/",
  txn_history: "/transactions/me",
  account_details: "/accounts/me",
  get_user_by_mobile: "/users/mobile",
  update_profile: "/users/me",
  reset_pin: "/accounts/me/pin",
  raise_dispute: "/disputes/",
  txn_disputes: "/disputes/me",
  profile: "users/authenticated/profile",
  me: "users/authenticated/me",
  hasAccess: "users/authenticated/masterlist",
  searchAutosuggest: "search/autosuggest?search",
  allResearchCategory: "research-categories/all",
  allResearchCategoryMasterlist: "research-categories/masterlists",
  masterlistAgraphySection: "agraphy",
  awards: "economics/awards-honours",
  screening: "economics/screenings",
  screeningFilter: "economics/screenings/filter",
  integratedTimeline: "body-of-work/integrated-timeline",
  integratedTimelineYearRange: "body-of-work/integrated-timeline/yearRange",
  integratedTimelineYearFilter: "body-of-work/integrated-timeline/year/filter",
  castCrew: "body-of-work/cast-crew",
  introductionFilm: "introduction/film",
  filmSpecification: "introduction/film/specifications",
  synopsis: "body-of-work/synopsis",
  cast: "body-of-work/cast",
  credits: "body-of-work/credits",
  lyricsSoundtrack: "body-of-work/lyrics-soundtrack",
  filmography: "body-of-work/filmography",
  exhibitions: "body-of-work/exhibitions",
  editorial: "body-of-work/editorial",
  filmographyFilter: "body-of-work/filmography/filter",
  filmographyPerson: "body-of-work/filmography/person",
  personality: "introduction/personality",
  personalityEducation: "introduction/personality/education",
  personalityTeachingInfrastructure:
    "introduction/personality/teaching-infrastructure",
  film: "film",
  auction: "auction/",
  lot: "lot/",
  lots: "lots",
  artwork: "artwork",
  explore: "explore",
  masterlists: "masterlists",
  postsFeatured: "posts/featured",
  songs: "songs",
  userAccess: "hasAccess",
  stages: "stages",
  event: "introduction/event",
  object: "introduction/object",
  essays: "body-of-work/essays",
  exhibits: "body-of-work/exhibits",
  economics: "economics/market-analysis",
  all: "body-of-work/all",
  brandAmbassdorShip: "body-of-work/brand-ambassadorship",
  econSeminars: "body-of-work/seminars",
  scholarshipLettersScribbles: "body-of-work/scholarship/letters-scribbles",
  scholarshipEssays: "body-of-work/scholarship/essays",
  editions: "body-of-work/editions",
  chronology: "chronology",
  illustratedBookData:
    "body-of-work/scholarship/publications/illustrated-books",
  authoredBookData:
    "body-of-work/scholarship/publications/authored-edited-books",
  location: "introduction/location",
  topAuctionSales: "economics/auction-sales",
  virtualtour: "body-of-work/virtual_tours",
  catalogue: "catalogue",
  artistExhibits: "exhibits/person-artist",
  print: "body-of-work/media-and-reportage/print",
  films: "admin/film/masterlists/film",
  filmBasic: "general/basic",
  filmSpecifications: "introduction/specification",
  filmLandingPage: "general/landing-page",
  filmPreface: "introduction/preface",
  filmEstablishment: "introduction/establishment",
  filmEditorial: "bodyofwork/editorial",
  filmSynopsis: "bodyofwork/synopsis",
  filmWatch: "bodyofwork/watchfilm",
  filmLyrics: "bodyofwork/lyrics-soundtrack",
  filmCreditsCasts: "bodyofwork/creditscasts",
  filmEditorialImages: "bodyofwork/editorial-images",
  archive: "admin/archive",
  archiveBulk: "admin/archive/bulk",
  archiveBulkEditConfig: "admin/archive/bulk-edit/config",
  videos: "admin/videos",
  libraries: "admin/libraries",
  librariesBulk: "admin/libraries/bulk",
  librariesBulkEditConfig: "admin/libraries/bulk-edit/config",
  posts: "admin/posts",
  projects: "admin/projects",
  insights: "admin/insights",
  researchCategories: "admin/research-categories",
  newsletters: "admin/newsletters",
  calendarEvents: "admin/calendar/events",
  calendarFocusOfTheDay: "admin/calendar/focus-of-the-day",
  sections: "sections",
  flipBooks: "admin/flip-books",
  virtualTours: "admin/virtual-tours",
  genres: "admin/genres",
  subSections: "sections/sub-sections",
  documentTypes: "admin/document-types",
  documentTypesUniqueFromExcel: "admin/document-types/unique-from-excel",
  masterlistAliasSuggestions: "admin/masterlist-alias-suggestions",
  countries: "admin/countries",
  adminPersonality: "admin/personality/masterlists/personality",
  adminTheme: "admin/theme/masterlists/theme",
  adminFeatured: "admin/featured/masterlists/featured",
  adminInstitution: "admin/institution/masterlists/institution",
  personalia: "introduction/personalia",
  education: "introduction/education",
  teachingInfrastructure: "introduction/teaching-infrastructure",
  personalitylistAliasSuggestions:
    "admin/personality/masterlists/personality-alias-suggestion",
  institutionlistAliasSuggestions:
    "admin/institution/masterlists/institution-alias-suggestion",
  adminLocation: "admin/location",
  adminEventMasterlist: "admin/event-masterlist",
  locationlistAliasSuggestions: "admin/location/location-suggestions",
  adminDerive: "admin/object/derive",
  adminLoadData: "admin/object/loadData",
  adminAlgoliaTrigger: "admin/object/updateAlgolia",
  auditLog: "admin/audit_logs",
  export: "admin/export",
  exportList: "admin/export/list",
  fileStats: "admin/file_stats",
  eventList: "admin/events",
  agraphyfile: "admin/agraphy",
  agraphyfileCommit: "admin/agraphy/commit",
  colorlistAliasSuggestions: "admin/film/color-suggestions",
  languageAliasSuggestions: "admin/language/dropdown",
  masterlistTypes: "admin/admin_users/masterlistTypes",
  masterlistSubTypes: "admin/admin_users/masterlistSubTypes",
  statesIndia: "states/india",
  explore_page: "explore/masterlists",
  explore_search_hints: "explore/search-hints",
  staticPages: "admin/static_pages",
  multiLingual: "admin/multiLingual",
  adminUsers: "admin/admin_users",
  savedFilters: "admin/saved-filters",
};
